import {
  LOGIN_USER,
  LOGIN_SUCCESS,
  LOGIN_ERROR,
  LOGOUT_USER,
  LOGOUT_SUCCESS,
  LOGOUT_ERROR,
} from "./actionTypes"

export const loginUser = data => {
  return {
    type: LOGIN_USER,
    payload: data,
  }
}

export const loginSuccess = user => {
  return {
    type: LOGIN_SUCCESS,
    payload: user,
  }
}

export const loginError = error => {
  return {
    type: LOGIN_ERROR,
    payload: error,
  }
}

export const logoutUser = data => {
  return {
    type: LOGOUT_USER,
    payload: data,
  }
}

export const logoutSuccess = () => {
  return {
    type: LOGOUT_SUCCESS,
    payload: {},
  }
}

export const logoutError = error => {
  return {
    type: LOGOUT_ERROR,
    payload: error,
  }
}